import {
	AuthCredentials,
	AuthInterface,
} from '../../interfaces/Auth.interfaces';
import { api } from '../slices/api';

// Define a service using a base URL and expected endpoints
export const extendedApiSlice = api.injectEndpoints({
	endpoints: (builder) => ({
		login: builder.mutation<AuthCredentials, AuthInterface>({
			query: (values) => ({
				url: 'auth/login/',
				method: 'POST',
				body: values,
			}),
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLoginMutation } = extendedApiSlice;
